import { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import ProductTagService from 'services/product_tag';
import { useApp } from 'contexts/app';

const service = new ProductTagService();

const useTag = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({});
  const { modal, showLoading, prompt } = useApp();

  const onSearch = async (searchFilter) => {
    const postData = { info: searchFilter?.info };
    const list = await service.list(postData);
    setData(Array.isArray(list) ? list : []);
  };

  const delaySearch = useMemo(() => _.debounce(onSearch, 500, { leading: false }), []);

  useEffect(() => {
    delaySearch(filter);

    return () => {
      delaySearch.cancel();
    };
  }, [delaySearch, filter]);

  const setFilterValue = (name, value) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      [name]: value,
    }));
  };

  const loadData = async () => {
    const list = await service.list({ info: filter?.info });
    setData(Array.isArray(list) ? list : []);
  };

  const createTag = () => {
    prompt({
      title: 'Tạo tag',
      label: 'Nhập tên',
      onOk: async (text) => {
        showLoading(true);
        await service.create({ name: text });
        await loadData();
        showLoading(false);
      },
    });
  };

  const editTag = (id) => {
    prompt({
      title: 'Chỉnh sửa',
      label: 'Nhập tên',
      onOk: async (text) => {
        showLoading(true);
        await service.update({ name: text, id });
        await loadData();
        showLoading(false);
      },
    });
  };

  const deleteTag = (id) => {
    modal.confirm({
      title: 'Xoá?',
      content: 'Bạn có chắc chắn muốn xoá',
      onOk: async () => {
        showLoading(true);
        await service.delete(id);
        await loadData();
        showLoading(false);
      },
    });
  };

  return {
    data,
    filter,
    setFilterValue,
    createTag,
    editTag,
    deleteTag,
  };
};

export default useTag;